import { GridColDef } from '@mui/x-data-grid'
import { formatDateHourMinute } from '../../utils/strings'

const useRegistroTable = () => {

    const columns: GridColDef[] = [
        {
            field: 'codigoRegistro',
            headerName: 'Código',
            width: 160
        },
        {
            field: 'nombreProfesor',
            headerName: 'Nombre',
            width: 200
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 220
        },
        {
            field: 'ciudad',
            headerName: 'Ciudad',
            width: 130
        },
        {
            field: 'puesto',
            headerName: 'Puesto',
            width: 160
        },
        {
            field: 'nivelEducativo',
            headerName: 'Nivel educativo',
            width: 160
        },
        {
            field: 'fechaAsistencia',
            headerName: 'Fecha asistencia',
            width: 180,
            valueGetter: (params: any) => params.row.fechaAsistencia ? formatDateHourMinute(params.row.fechaAsistencia) : '—'
        },
        {
            field: 'fechaAlta',
            headerName: 'Fecha de registro',
            width: 180,
            valueGetter: (params: any) => params.row.fechaAlta ? formatDateHourMinute(params.row.fechaAlta) : '—'
        }
    ]

    return { columns }
}

export default useRegistroTable
